/**
 * Shopify Product Hotspot / Lookbook Controller
 */
if (!customElements.get('m-product-hotspot')) {
  customElements.define('m-product-hotspot', class MProductHotspot extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.activeItem = null;
      this.init();
    }

    init() {
      this.items = Array.from(this.querySelectorAll('.js-hotspot-item'));
      if (this.items.length === 0) return;

      this.bindEvents();
      this.setupShopifyEditor();
    }

    bindEvents() {
      this.items.forEach((item) => {
        const dot = item.querySelector('.js-hotspot-dot');
        const closeBtn = item.querySelector('.js-card-close');

        if (dot) {
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleHotspot(item);
          });
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.closeHotspot(item);
          });
        }

        // Prevent card clicks from bubbling up to document click listener
        const card = item.querySelector('.js-hotspot-card');
        if (card) {
          card.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      });

      // Close active hotspot when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.closeAllHotspots();
        }
      });

      // ESC key to close active hotspot
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllHotspots();
        }
      });
    }

    toggleHotspot(targetItem) {
      const isActive = targetItem.classList.contains('is-active');

      // Close all other hotspots first
      this.items.forEach((item) => {
        if (item !== targetItem) {
          this.closeHotspot(item);
        }
      });

      if (isActive) {
        this.closeHotspot(targetItem);
      } else {
        this.openHotspot(targetItem);
      }
    }

    openHotspot(item) {
      if (!item) return;
      item.classList.add('is-active');
      const dot = item.querySelector('.js-hotspot-dot');
      if (dot) dot.setAttribute('aria-expanded', 'true');
      this.activeItem = item;
    }

    closeHotspot(item) {
      if (!item) return;
      item.classList.remove('is-active');
      const dot = item.querySelector('.js-hotspot-dot');
      if (dot) dot.setAttribute('aria-expanded', 'false');
      if (this.activeItem === item) {
        this.activeItem = null;
      }
    }

    closeAllHotspots() {
      this.items.forEach((item) => this.closeHotspot(item));
    }

    setupShopifyEditor() {
      // Real-time Shopify Theme Editor interactivity
      if (!window.Shopify || !Shopify.designMode) return;

      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        const targetItem = this.items.find(item => item.dataset.blockId === blockId);
        if (targetItem) {
          this.openHotspot(targetItem);
        }
      });

      document.addEventListener('shopify:block:deselect', (e) => {
        const blockId = e.detail.blockId;
        const targetItem = this.items.find(item => item.dataset.blockId === blockId);
        if (targetItem) {
          this.closeHotspot(targetItem);
        }
      });
    }
  });
}
